import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import ContactSection from "./components/ContactSection";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import Sitemap from "./pages/Sitemap";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import AboutSchool from "./pages/AboutSchool";
import EnquiryForm from "./pages/EnquiryForm";
import RulesSection from "./pages/RulesSection";
import Infrastructure from "./pages/Infrastructure";
import DirectorMassage from "./pages/DirectorMessage";
import Administration from "./pages/Administration";
import AdmissionProcedure from "./pages/AdmissionProcedure";
import PrincipalMessage from "./pages/PrincipalMessage";
import CampusOverview from "./pages/CampusOverview";
import Cafeteria from "./pages/Cafeteria";
import StudentDocuments from "./pages/StudentDocuments";
import FeeStructure from "./pages/FeeStructure";
import GallerySection from "./pages/GallerySection";
const Layout = ({ children }) => (
  <div className="overflow-x-hidden">
    <Navbar />
    <main>{children}</main>
    <Footer />
  </div>
);
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/contact" element={<Layout><ContactSection /></Layout>} />
        <Route path="/privacy-policy" element={<Layout><PrivacyPolicy /></Layout>} />
        <Route path="/terms-of-service" element={<Layout><TermsOfService /></Layout>} />
        <Route path="/sitemap" element={<Layout><Sitemap /></Layout>} />
        <Route path="/about-school" element={<Layout><AboutSchool /></Layout>} />
        <Route path="/enquiry-form" element={<Layout><EnquiryForm /></Layout>} />
        <Route path="/rules-section" element={<Layout><RulesSection /></Layout>} />
        <Route path="/infrastructure" element={<Layout><Infrastructure /></Layout>} />
        <Route path="/chairman-message" element={<Layout><DirectorMassage/></Layout>}/>
        <Route path="/administration" element={<Layout><Administration/></Layout>} />
        <Route path="/admission-procedure" element={<Layout><AdmissionProcedure/></Layout>} />
        <Route path="/principal-massage" element={<Layout><PrincipalMessage/></Layout>} />
        <Route path="/campus-overview"element={<Layout><CampusOverview/></Layout>}/>
        <Route path="/cafeteria"element={<Layout><Cafeteria/></Layout>}/>
        <Route path="/student-documents"element={<Layout><StudentDocuments/></Layout>}/>
        <Route path="/fee-structure"element={<Layout><FeeStructure/></Layout>}/>
        <Route path="/gallery"element={<Layout><GallerySection/></Layout>}/>
        <Route
          path="*"
          element={
            <Layout>
              <div className="min-h-[60vh] flex items-center justify-center text-2xl font-bold text-red-600">
                Page Not Found
              </div>
            </Layout>
          }
        />
      </Routes>
    </Router>
  );
}
export default App;